import { resolve } from 'rsvp';
import Base from 'ember-simple-auth/authenticators/base';
import { getAccessCookie } from 'cio/utils/auth-cookies';

// placeholder custom ember-simple-auth authenticator, using _access cookie, which is assumed to be always present
// it is de facto a temporary compatibility layer, until migration of logged-out pages from Unity

export default class CookieAccessTokenAuthenticator extends Base {
  restore() {
    return resolve({
      accessToken: getAccessCookie() as string,
    });
  }

  authenticate() {
    return resolve({
      accessToken: getAccessCookie() as string,
    });
  }
}
